export default __webpack_public_path__ + "static/media/marco.d208425f.webp";